/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { RqthRefusalReason } from './';
import {
    RqthRefusalReasonFromJSON,
    RqthRefusalReasonFromJSONTyped,
    RqthRefusalReasonToJSON,
} from './';

/**
 * 
 * @export
 * @interface RqthRefusalRequest
 */
export interface RqthRefusalRequest {
    /**
     * 
     * @type {RqthRefusalReason}
     * @memberof RqthRefusalRequest
     */
    refusalReason: RqthRefusalReason;
    /**
     * Email content to be sent to the freelancer explaining the refusal.
     * @type {string}
     * @memberof RqthRefusalRequest
     */
    emailContent?: string;
}

/**
 * Check if a given object implements the RqthRefusalRequest interface.
 */
export function instanceOfRqthRefusalRequest(value: object): value is RqthRefusalRequest {
    if (!('refusalReason' in value) || value['refusalReason'] === undefined) return false;
    return true;
}

export function RqthRefusalRequestFromJSON(json: any): RqthRefusalRequest {
    return RqthRefusalRequestFromJSONTyped(json, false);
}

export function RqthRefusalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RqthRefusalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'refusalReason': RqthRefusalReasonFromJSON(json['refusalReason']),
        'emailContent': json['emailContent'] == null ? undefined : json['emailContent'],
    };
}

export function RqthRefusalRequestToJSON(value?: RqthRefusalRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'refusalReason': RqthRefusalReasonToJSON(value['refusalReason']),
        'emailContent': value['emailContent'],
    };
}

